import ApiProvider from "./ApiProvider";
import { User } from '../models/Booking'

export default class UserProvider extends ApiProvider {
    checkEmailExists (email: string): Promise<boolean> {
      const url = this.baseUrl + '/users/me/exists?email=' + encodeURIComponent(email)
      
      return this.get(url)
        .then((response) => {
          const payload = response.data.payload

          return payload
        })
    }

    attemptLogin (email: string, password: string): Promise<any> {
        const url = this.baseUrl + '/login'
        const params = {
            email: email,
            password: password,
            remember: true,
        }

        const options = {
            withCredentials: true
        }

        return this.post(url, params, options)
            .then((response) => {
                const payload = response.data.payload

                if (payload.logged_in) {
                    return new User(payload)
                }

                throw 'Incorrect username or password'
            })
    }
}


// WEBPACK FOOTER //
// ./src/services/UserProvider.ts